import { Toaster as SonnerToaster } from 'sonner';

export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        classNames: {
          toast:
            'bg-card text-foreground border shadow-lg rounded-lg font-sans',
          title: 'text-sm font-semibold',
          description: 'text-sm text-muted-foreground',
          success: 'border-green-500/30',
          error: 'border-destructive/30',
          warning: 'border-yellow-500/30',
          info: 'border-primary/30',
        },
      }}
      richColors
      closeButton
    />
  );
}
